<template>
  <div class="md-layout ">
    <div class="md-layout-item md-size-95">
      <h1 class="md-display-1">Список касс</h1>
    </div>

<!--    <CashFilter v-on:changeCashFilter="changeCashFilter"/>-->
    <CashTable :key="keyTable" v-on:editCasbox="editCashBox"/>
    <CashEdit :key="keyDialog+'EditDialog'" :openDialog="openDialog" @closeDialogSuccess="closeDialog(true)" @closeDialog="closeDialog()"/>
  </div>
</template>

<script>
import Vuex from 'vuex'
import store from '@/store'
import CashFilter from './CashFilter'
import CashTable from './CashTable'
import CashEdit from './CashEdit'

const cashFilter = new Vuex.Store({
  state: {
    filtersCash: {
      country_code: store.getters.regionUser,
      shop_id: null,
      cashbox_id: null
    },
    search: '',
    pagination: {
      current_page: 0,
      count_page: 0
    },
    editId: null,
    shopId: null
  },
  mutations: {
    setCashFilter (obj, result) {
      if (result['value'] === 'deleteFilter') {
        this.state.filtersCash[result['name']] = null
      } else {
        this.state.filtersCash[result['name']] = result['value']
      }
    },
    resetPagination () {
      this.state.pagination = {
        current_page: 0,
        count_page: 0
      }
    }
  }
})

export default {
  data () {
    return {
      showTable: 1,
      filter: {},
      keyTable: 1,
      keyDialog: 1,
      openDialog: 0,
      keyDialogCreate: 1,
      openCreateDialog: 0
    }
  },
  name: 'CashIndex',
  components: { CashEdit, CashTable, CashFilter },
  store: cashFilter,
  methods: {
    changeCashFilter () {
      this.$store.commit('resetPagination')
      this.keyTable++
    },
    editCashBox () {
      this.keyDialog++
      this.openDialog = 1
    },
    closeDialog (flag) {
      this.openDialog = 0
      this.$store.state.editId = null
      if (flag === true) {
        this.keyTable++
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cashbox/CashIndex.vue